// extracted by mini-css-extract-plugin
module.exports = {"text-center":"styles_text-center__3OxO3","ag-header-cell-label":"styles_ag-header-cell-label__3VsSJ"};